import styled from 'styled-components';

export const StyledMessageDiv = styled.div`
  align-items: center;
  display: flex;

  > .anticon {
    margin: 0 !important;
    top: 3px !important;
  }

  > .anticon-close {
    color: ${({ theme }) => theme.secondaryTextColor} !important;
    &:hover {
      color: ${({ theme }) => theme.descriptionColor} !important;
    }
  }
`;

export const StyledMessageContent = styled.div`
  text-align: left;
  margin: 0 8px;
`;
